import React, { useState } from "react";

import { Box, makeStyles, MenuItem } from "@material-ui/core";
import _ from "lodash";

import InputSearch from "components/Input/InputSearch";
import DynamicList from "components/List/DynamicList";
import { IOption } from "model/application/components";

const styles = {
  SearchDropdown: {
    padding: "16px",
  },
  SearchDropdownItems: {
    margin: "0 -16px",
    maxHeight: "264px",
    minWidth: "10rem",
    overflow: "auto",
  },
};

const useStyles = makeStyles(styles as any);

export interface ISearchDropdownProps {
  options?: IOption[];
  onSelectOption: (e: any, option: IOption) => any;
  renderOption?: (option: IOption, index: number) => React.ReactNode;
}

export const SearchDropdown: React.FunctionComponent<ISearchDropdownProps> = ({
  options,
  onSelectOption,
  renderOption,
}: ISearchDropdownProps) => {
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState("");

  const filteredOptions = _.filter(options, (o) => {
    return o.label?.toLowerCase().includes(searchValue.toLowerCase());
  });

  const defaultRenderOption = (option: IOption, _index: number) => (
    <MenuItem
      key={option.key}
      onClick={(e: any) => onSelectOption(e, option)}
      style={{ fontSize: 16 }}
    >
      {option.label}
    </MenuItem>
  );

  const buildMenuItemFunction = (index: number) => {
    const option = filteredOptions[index];
    if (!option) {
      return null;
    }
    return renderOption
      ? renderOption(option, index)
      : defaultRenderOption(option, index);
  };

  return (
    <div className={classes.SearchDropdown}>
      <InputSearch onChange={(value) => setSearchValue(value)} />

      <Box marginBottom="8px" />

      <Box className={classes.SearchDropdownItems}>
        <DynamicList
          buildMenuItemFunction={buildMenuItemFunction}
          listSize={filteredOptions.length}
          maxItems={20}
        />
      </Box>
    </div>
  );
};

export default SearchDropdown;
